var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_8610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9873 4.55674C21.9593 4.37974 21.6753 2.78974 20.5233 1.62874C19.3663 0.496739 17.7703 0.216739 17.5923 0.188739C17.3553 0.149739 17.1133 0.199739 16.9103 0.325739C16.8393 0.369739 15.7963 1.02274 13.7373 2.76374C14.7963 3.13774 16.1653 3.78674 17.2753 4.87274C18.3893 5.96274 19.0553 7.30374 19.4373 8.34374C21.1573 6.33374 21.8043 5.31574 21.8473 5.24574C21.9753 5.04074 22.0253 4.79574 21.9873 4.55674Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9499 4.32812C10.8769 5.29612 9.6279 6.47212 8.1979 7.89212C2.1349 13.9121 0.544898 16.3191 0.479898 16.4181C0.388898 16.5581 0.333898 16.7191 0.320898 16.8851L0.00189816 20.9561C-0.0201018 21.2481 0.0848982 21.5341 0.291898 21.7411C0.479898 21.9291 0.734898 22.0341 0.999898 22.0341C1.0249 22.0341 1.0509 22.0341 1.0769 22.0311L5.1779 21.7151C5.3429 21.7021 5.5019 21.6491 5.6409 21.5601C5.7409 21.4961 8.1639 19.9171 14.2259 13.8981C15.6879 12.4461 16.8939 11.1821 17.8809 10.1011C17.7299 9.45213 17.2029 7.60012 15.8759 6.30312C14.5299 4.98612 12.5939 4.47013 11.9499 4.32812Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_8610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.105469)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4009cc3d1e2216fe9b0b851e8de48792.svg";
export { ForwardRef as ReactComponent };